exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".login-form {\n  max-width: 350px;\n  margin: 100px auto 0 auto;\n  background-color: white;\n  border-radius: 15px;\n  padding: 25px;\n}\n@media only screen and (max-width: 375px) {\n  .login-form {\n    max-width: 300px;\n  }\n}\n.login-form-forgot {\n  float: right;\n}\n.login-form-button {\n  width: 100%;\n}\n.submit-button-container {\n  margin-bottom: 0 !important;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/less-loader/dist/cjs.js?{"modifyVars":{"@primary-color":"#cc0000","@layout-body-background":"#cc0000","@layout-header-background":"white"}}!./src/components/login-form/styles.less
// module id = 1580
// module chunks = 0